import { Environment } from './types'

export interface ApiConfig {
  userApiBase: string // 用户中心 API 基地址
  authApiBase: string // 授权/登录 API 基地址
  localhostBase: string // 客户端本地服务基地址
}

export interface SiteConfig {
  passport: string // 登录站点
}

const API_CONFIG_MAP: Record<Environment, ApiConfig> = {
  production: {
    userApiBase: 'https://user-api-v2.oray.com',
    authApiBase: 'https://user-auth.oray.com',
    localhostBase: 'https://localhost.oray.com',
  },
  staging: {
    userApiBase: 'https://user-api-v2.oray.com',
    authApiBase: 'https://user-auth.oray.com',
    localhostBase: 'https://localhost.oray.com',
  },
  testing: {
    userApiBase: 'https://user-api-v2.oraybeta.com',
    authApiBase: 'https://user-auth.oraybeta.com',
    localhostBase: 'https://localhost.oraybeta.com',
  },
  development: {
    userApiBase: 'https://user-api-v2.oraybeta.com',
    authApiBase: 'https://user-auth.oraybeta.com',
    localhostBase: 'https://localhost.oraybeta.com',
  },
}

const SITE_CONFIG_MAP: Record<Environment, SiteConfig> = {
  production: {
    passport: 'https://passport.oray.com',
  },
  staging: {
    passport: 'https://passport.oray.com',
  },
  testing: {
    passport: 'https://passport.oraybeta.com',
  },
  development: {
    passport: 'https://passport.oraybeta.com',
  },
}

export function getApiConfig(env: Environment = 'production'): ApiConfig {
  return API_CONFIG_MAP[env] || API_CONFIG_MAP.production
}

export function getSiteConfig(env: Environment = 'production'): SiteConfig {
  return SITE_CONFIG_MAP[env] || SITE_CONFIG_MAP.production
}
